import styled from 'styled-components';
import { primaryColor, primaryColorDark } from '../../config/colors';

export const NotFoundScreenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
  min-height: 100%;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export const NotFoundTitle = styled.h1`
  color: ${primaryColor};
  font-size: 3.875rem;
`;

export const NotFoundSubtitle = styled.h1`
  color: ${primaryColorDark};
`;
